import React, { useEffect, useState } from "react";
import MasterLayout from "../Sections/MasterLayout";
import Switch from "react-switch";
import Loader from "./Loader";
import DeleteModal from "../Sections/DeleteModal";
import SuccesModal from "../Sections/SuccesModal";
import { FaEye } from "react-icons/fa";
import {
  get_user_data,
  user_active_deactive_status,
  server_post_json,
} from "../../ServiceConnection/serviceconnection";

export default function AllUsers() {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [successModal, setSuccessModal] = useState(false);
  const [successTitle, setSuccessTitle] = useState("");
  const [successSubtitle, setSuccessSubtitle] = useState("");
  const [detailModal, setDetailModal] = useState(false);
  const [selectedUserDetails, setSelectedUserDetails] = useState(null);

  // Fetch all users
  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const response = await server_post_json(get_user_data);
      setUsers(Array.isArray(response.data?.data) ? response.data.data : []);
    } catch (err) {
      setUsers([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Fetch single user details
  const fetchUserDetails = async (user_id) => {
    try {
      setIsLoading(true);
      const response = await server_post_json(get_user_data, { user_id });
      setSelectedUserDetails(response.data?.data || null);
      setDetailModal(true);
    } catch (err) {
      console.error(err);
      // You can add a error modal or toast here if needed
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewClick = (user_id) => {
    fetchUserDetails(user_id);
  };

  const handleToggleClick = (user) => {
    const nextStatus = user.status === "active" ? "inactive" : "active";

    setSelectedUser({
      ...user,
      nextStatus,
    });

    setConfirmModal(true);
  };

  // Confirm deactivate/activate
  const handleDeactivate = async () => {
    try {
      setIsLoading(true);

      const payload = {
        user_id: selectedUser.user_id,
        status: selectedUser.nextStatus,
      };

      await server_post_json(user_active_deactive_status, payload);

      setSuccessTitle(
        selectedUser.nextStatus === "active"
          ? "User Activated"
          : "User Deactivated"
      );
      setSuccessSubtitle(
        `The user has been successfully ${
          selectedUser.nextStatus === "active" ? "activated" : "deactivated"
        }.`
      );

      setConfirmModal(false);
      setSuccessModal(true);
      fetchUsers();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MasterLayout>
      {isLoading && <Loader />}

      <div className="bg-white py-6 px-4 rounded-[5px] border shadow-none">
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800">All Users</h2>
          <p className="text-sm text-gray-500 mt-1">
            Manage users & activation status
          </p>
        </div>

        {/* Responsive Container */}
        <div className="overflow-x-auto -mx-4 sm:mx-0">
          {/* Desktop/Table View */}
          <table className="hidden md:table min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  #
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  User Id
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Name
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Email
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Phone
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {users.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-12 text-gray-500">
                    No users found
                  </td>
                </tr>
              ) : (
                users.map((user, index) => (
                  <tr key={user.user_id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      {index + 1}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {user.user_id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {user.firstName} {user.lastName}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {user.email}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {user.phone || "—"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${
                          user.status === "active"
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                        }`}
                      >
                        {user.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center flex items-center justify-center space-x-4">
                      <Switch
                        onChange={() => handleToggleClick(user)}
                        checked={user.status === "active"}
                        onColor="#22c55e"
                        offColor="#ef4444"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={24}
                        width={46}
                      />
                      <button
                        onClick={() => handleViewClick(user.user_id)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <FaEye size={20} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Mobile Card View */}
          <div className="md:hidden space-y-4 px-4 sm:px-0">
            {users.length === 0 ? (
              <div className="text-center py-12 text-gray-500">
                No users found
              </div>
            ) : (
              users.map((user, index) => (
                <div
                  key={user.user_id}
                  className="bg-gray-50 rounded-lg p-4 shadow-sm border"
                >
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <div className="font-semibold text-gray-900">
                        #{index + 1} {user.firstName} {user.lastName}
                      </div>
                      <div className="text-sm text-gray-600 mt-1">{user.email}</div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <Switch
                        onChange={() => handleToggleClick(user)}
                        checked={user.status === "active"}
                        onColor="#22c55e"
                        offColor="#ef4444"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={24}
                        width={46}
                      />
                      <button
                        onClick={() => handleViewClick(user.user_id)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <FaEye size={20} />
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <span className="text-gray-500">Phone:</span>
                      <div className="font-medium">{user.phone || "—"}</div>
                    </div>
                    <div>
                      <span className="text-gray-500">Status:</span>
                      <div>
                        <span
                          className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full mt-1 ${
                            user.status === "active"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {user.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* Confirm Deactivate/Activate Modal */}
      <DeleteModal
        open={confirmModal}
        onClose={() => setConfirmModal(false)}
        onConfirm={handleDeactivate}
        title={
          selectedUser?.nextStatus === "inactive"
            ? "Deactivate User?"
            : "Activate User?"
        }
        subtitle={
          selectedUser?.nextStatus === "inactive"
            ? "This user will lose access to the system."
            : "This user will regain access to the system."
        }
        confirmText={
          selectedUser?.nextStatus === "inactive" ? "Deactivate" : "Activate"
        }
        lodingText={
          selectedUser?.nextStatus === "inactive"
            ? "Deactivating..."
            : "Activating..."
        }
      />

      {/* Success Modal */}
      <SuccesModal
        open={successModal}
        onClose={() => setSuccessModal(false)}
        title={successTitle}
        subtitle={successSubtitle}
        autoClose
        autoCloseTime={2500}
      />

      {/* User Detail Modal */}
      {detailModal && selectedUserDetails && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">User Details</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <p>
                <strong>Name:</strong> {selectedUserDetails.firstName}{" "}
                {selectedUserDetails.lastName}
              </p>
              <p>
                <strong>Email:</strong> {selectedUserDetails.email}
              </p>
              <p>
                <strong>Phone:</strong> {selectedUserDetails.phone || "—"}
              </p>
              <p>
                <strong>Shipping Address:</strong>{" "}
                {selectedUserDetails.address || ""},{" "}
                {selectedUserDetails.city || ""},{" "}
                {selectedUserDetails.state || ""}{" "}
                {selectedUserDetails.pincode || ""},{" "}
                {selectedUserDetails.country || ""}
              </p>
              <p>
                <strong>Status:</strong> {selectedUserDetails.status}
              </p>
              <p>
                <strong>Role:</strong> {selectedUserDetails.role}
              </p>
              <p>
                <strong>Email Verified:</strong>{" "}
                {selectedUserDetails.isEmailVerified ? "Yes" : "No"}
              </p>
              <p>
                <strong>Created At:</strong>{" "}
                {new Date(selectedUserDetails.createdAt).toLocaleString()}
              </p>
              <p>
                <strong>Orders Count:</strong> {selectedUserDetails.ordersCount}
              </p>
            </div>

            <h3 className="text-lg font-bold mt-6 mb-2">Orders</h3>
            {selectedUserDetails.orders &&
            selectedUserDetails.orders.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 text-left font-semibold text-gray-600">
                        Order ID
                      </th>
                      <th className="px-4 py-2 text-left font-semibold text-gray-600">
                        Date
                      </th>
                      {/* Add more headers based on Order model fields, e.g., Total, Status */}
                      <th className="px-4 py-2 text-left font-semibold text-gray-600">
                        Total Amount
                      </th>
                      <th className="px-4 py-2 text-left font-semibold text-gray-600">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {selectedUserDetails.orders.map((order) => (
                      <tr key={order.order_id}>
                        <td className="px-4 py-2">{order.order_id}</td>
                        <td className="px-4 py-2">
                          {new Date(order.createdAt).toLocaleString()}
                        </td>
                        {/* Add more cells based on fields */}
                        <td className="px-4 py-2">
                          {order.totalAmount || "—"} {/* Assume field */}
                        </td>
                        <td className="px-4 py-2">{order.status || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-gray-500">No orders found</p>
            )}

            <button
              onClick={() => setDetailModal(false)}
              className="mt-6 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </MasterLayout>
  );
}